import PropTypes from "prop-types";
import React from "react";
import Dropzone from "../../common/file-uploader/drop-zone";
import UploaderIcon from "./UploaderIcon";

const ReceiptUploader = ({ className, disabled, error, onChange, ...rest }) => {
  return (
    <div>
      <Dropzone className onDrop={acceptedFiles => onChange(acceptedFiles)} disableClick={disabled} {...rest}>
        <UploaderIcon {...rest} />
      </Dropzone>
    </div>
  );
};

ReceiptUploader.propTypes = {
  className: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ReceiptUploader;



// WEBPACK FOOTER //
// ./components/claim/widgets/receipt-uploader.js